import { Stack, Box, Typography, IconButton } from '@vapor/material'
import { useTranslation } from 'react-i18next'
import useFormatDate from 'src/app/hooks/current-locale/use-format-date'
import { paddingChat, noteColorChat } from './common'
import { MessageFragment } from 'src/api/api.generated'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faX } from '@fortawesome/pro-regular-svg-icons'
import { useConfirm } from 'hic-components'

export default function ChatBody({ messages, backgroundColor, deleteNote }: { messages: MessageFragment[]; backgroundColor?: string; deleteNote: (note: MessageFragment) => Promise<void> }) {
  const formatDate = useFormatDate()
  const { t } = useTranslation()
  const confirm = useConfirm()

  if (messages.length === 0) {
    return (
      <Typography textAlign="center" marginTop={4} flexGrow={1}>
        {t('pms.messages.no_messages_from_chat')}
      </Typography>
    )
  }

  return (
    <Stack
      sx={{ backgroundColor }}
      gap={2}
      padding={paddingChat}
      overflow="auto"
      flexGrow={1}
      flexDirection={'column-reverse'} /* using column-reverse so it is scrolled automatic to the last message */
    >
      {messages.map((message) => {
        return (
          <Box
            key={message.id}
            sx={{
              p: 2,
              maxWidth: '80%' /* TODO provare se va bene */,
              wordBreak: 'break-word',
              borderRadius: '0.25rem',
              backgroundColor: message.internalNote ? noteColorChat : message.externalUserId ? '#e5e4ea' : '#0b81ff',
              alignSelf: message.externalUserId ? 'start' : 'end',
              color: message.externalUserId || message.internalNote ? 'black' : 'white',
            }}
          >
            <Stack direction="row" gap={1} alignItems="start">
              <Typography variant="body" whiteSpace="pre-line" color="inherit" flexGrow={1}>
                {message.message}
              </Typography>
              {message.internalNote && (
                <IconButton
                  size="small"
                  sx={{ display: 'block', marginLeft: 'auto', padding: 0, minWidth: '0!important', minHeight: '0!important' }}
                  onClick={() => {
                    confirm({
                      confirmIsDanger: true,
                      title: t('pms.messages.delete_note'),
                      message: t('pms.messages.delete_note_message'),
                      confirmButtonText: t('pms.common.delete_it'),
                      cancelButtonText: t('pms.common.keep_it'),
                      onConfirm: () => {
                        deleteNote(message)
                      },
                    })
                  }}
                >
                  <FontAwesomeIcon icon={faX} size="xs" />
                </IconButton>
              )}
            </Stack>
            <Typography variant="caption" color="inherit" sx={{ display: 'block', textAlign: 'right' }}>
              {!message.externalUserId && `${t('pms.messages.operator')} - `}
              {message.auditable.createdOn ? formatDate(message.auditable.createdOn, 'iii PP') : ''} {t('pms.messages.at')}{' '}
              {message.auditable.createdOn ? formatDate(message.auditable.createdOn, 'HH:mm') : ''}
            </Typography>
          </Box>
        )
      })}
    </Stack>
  )
}
